import { render, staticRenderFns } from "./OrderDetailPage.vue?vue&type=template&id=f96d9956&scoped=true&"
import script from "./OrderDetailPage.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailPage.vue?vue&type=style&index=0&id=f96d9956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96d9956",
  null
  
)

export default component.exports